export default __webpack_public_path__ + "static/media/figuremap37.d6daea0b.png";